import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { SimpleSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';



const allowedEnvs = ["local", "development", "stage", "production"];
const envMap = {
  "local": "local",
  "development": "develop",
  "stage": "stage",
  "production": "prod",
};
const currentEnv = process.env.REACT_APP_ENV;

if (allowedEnvs.includes(currentEnv)) {
  const serviceName = 'mowaamah-frontend';
  const otelUrl = process.env.REACT_APP_OTEL_URL;
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const sanitizedApiBaseUrl = apiBaseUrl?.replace(/\/$/, '');
  const backendUrlRegex = new RegExp(`^${sanitizedApiBaseUrl}.*`);

  const resource = resourceFromAttributes({
    'service.name': serviceName,
    'deployment.environment': envMap[currentEnv],
  });

  const exporter = new OTLPTraceExporter({
    url: otelUrl,
  });

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new SimpleSpanProcessor(exporter)],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  const webTracerWithZone = provider.getTracer(serviceName);

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [backendUrlRegex],
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [backendUrlRegex],
      }),
    ],
  });
}
